import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-translate';
import AsyncSelect from 'react-select/async';
import PracticesService from 'services/PracticesService';
import DoctorsService from 'services/DoctorsService';
import { actionSetUsersList } from 'store/actions/userDataActions';
import Icon from 'components/Icons/Icon';

const UploadAsyncContacts = ({ control, name, disabled, isSecretary }) => {
  const t = useTranslate('analysis');
  const dispatch = useDispatch();
  const recipientsField = useRef();
  const practiceId = useSelector((state) => state.userAuthorizationReducer._id);
  const practitioners = useSelector((state) => state.practicesReducer.practice.people);
  const patients = useSelector(state => state.patientsReducer.patients);
  
  const customStyles = {
    control: (provided, state) => {
      const borderColor = state.isFocused ? '#fd7e14 !important' : '#e3e3e3';
      return {
        ...provided,
        backgroundColor: 'transparent',
        border: `1px solid ${borderColor}`,
        borderRadius: '30px',
        color: '#2c2c2c',
        lineHeight: 'normal',
        height: 'auto',
        fontSize: '0.8571em',
        transition:
          'color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out',
        boxShadow: 'none',
      };
    },
    indicatorsContainer: (provided) => {
      return {
        ...provided,
        display: 'none',
      };
    },
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };

  const loadRecipients = async (query) => {
    if (query.replaceAll(" ", "").length < 2) {
      return new Promise(resolve => {
        resolve([]);
      });
    }
    try {
      const result = await PracticesService.getContacts(practiceId, query, true, name);
      let list = [];

      console.log(result.data);

      if (isSecretary) {
        if ((result.data && result.data.length > 0)) {
          result.data.map((user) => {
            //If user can reply to patients or the recipients are doctors
            if (user.email && user.type == name) {
              list.push( {
                label: `${user.title ? `${user.title} ` : ""}${user.firstName} ${user.lastName} (${user.email})`,
                value: user.email,
                __score: user.score,
                __type: user.type
              });
            }
          });
        }
      } else {
        //User is not a secretary, only allow searches for its patients
        const filteredPatients = await DoctorsService.searchPatients(query, practiceId);
        //Append patients
        if ( (filteredPatients.data && filteredPatients.data.length > 0) ) {
          result.data.map(patient => {
            if (patient.email && patient.type == name) {
              const user = filteredPatients.data.find(u => u.auth_user_id === patient.auth_user_id);

              if (user) {
                  list.push({
                  label: `${patient.title ? `${patient.title} ` : ""}${patient.firstName} ${patient.lastName} (${patient.email})`,
                  value: patient.email,
                  __score: patient.score,
                  __type: "patient"
                });
              }
            }
          });
        }
      }

      if (!list.length) {
        throw new Error("No options");
      }

      list = list.sort((a,b) => {
        return b.__score - a.__score;
      })
      
      return new Promise((resolve) => {
        dispatch(actionSetUsersList([...practitioners, ...patients]));
        resolve(list);
      });
    } catch (error) {
      console.log(error);
      return new Promise((resolve) => {
        dispatch(actionSetUsersList([]));
        resolve([]);
      });
    }
  };

  //Custom format for the options
  const formatOptionLabel = (props) => {
    const { label, __type } = props;
    return (
    <div className='d-flex'>
      <div className='mr-2'>
        <Icon file={`${__type === "doctor" ? "hospital" : "user-header"}.svg`} width="21px" title="Practices" />
      </div>
      <div className="self-center">{label}</div>
    </div>
    )
  };

  return (
    <>
      <Controller
        as={
          <AsyncSelect
            cacheOptions
            loadOptions={loadRecipients}
            styles={customStyles}
            isLoading={true}
            noOptionsMessage={() => t('not-found')}
            ref={recipientsField}
            formatOptionLabel={formatOptionLabel}
            isDisabled={disabled}
          />
        }
        control={control}
        name={name}
        placeholder={t(name)}
      />
    </>
  );
};

export default UploadAsyncContacts;
